import {FIELD_LIST_INTRO_RESULT_MIRACULOUS_RETINOL_SERIES} from "../../../utils/input-field-list-static-page";
import {useDispatch, useSelector} from "react-redux";
import InputField from "./input-field";
import React from "react";
import {setMiraculousRetinolSeriesResultDetail} from "../../../reducers/miraculous-retinol-series.reducer";
import FormGeneralComponent from "../../../components/static-page/form-general.component";

const Result = () => {
    const dispatch = useDispatch()
    const {resultDetail} = useSelector(state => state.miraculousRetinolSeriesReducer)
    let fieldList = FIELD_LIST_INTRO_RESULT_MIRACULOUS_RETINOL_SERIES
    let showResult = {
        label: 'Result',
        key: 'show_result',
        activeText: 'Show',
        inActiveText: 'Hide',
        positionText: 'left'
    }
    const toggleList = [
        {
            title: 'Input Field',
            content: <InputField fieldList={fieldList} />
        }
    ]

    const onChange = (key, value) => {
        dispatch(setMiraculousRetinolSeriesResultDetail({[key]: value}))
    }

    const onSubmitHandler = (e) => {
        e.preventDefault()
        console.log(resultDetail)
        // submit form
    }

    return (
        <FormGeneralComponent
            data={resultDetail}
            switchToggleField={showResult}
            onChange={onChange}
            toggleList={toggleList}
            onSubmitHandler={onSubmitHandler}
            isLoading={false}
        />
    )
}

export default Result